import { h } from '../core/dom'
import { t, num } from '../i18n'
import { back } from '../core/router'
import { haptic } from '../core/haptics'

export function topbar(title?: string, onBack: () => void = back): HTMLElement {
  return h(
    'header',
    { class: 'topbar' },
    h(
      'button',
      {
        class: 'icon-btn flip',
        'aria-label': t().common.back,
        onclick: () => {
          haptic.tap()
          onBack()
        },
      },
      '←',
    ),
    title && h('h2', {}, title),
  )
}

export function toggle(checked: boolean, onChange: (v: boolean) => void): HTMLElement {
  const el = h('button', {
    class: 'switch',
    role: 'switch',
    'aria-checked': String(checked),
    onclick: () => {
      const next = el.getAttribute('aria-checked') !== 'true'
      el.setAttribute('aria-checked', String(next))
      haptic.tap()
      onChange(next)
    },
  })
  return el
}

export function tile(
  glyph: string,
  label: string,
  sub: string | undefined,
  onClick: () => void,
  extraClass = '',
): HTMLElement {
  return h(
    'button',
    {
      class: `tile ${extraClass}`.trim(),
      onclick: () => {
        haptic.tap()
        onClick()
      },
    },
    h('span', { class: 'glyph' }, glyph),
    h(
      'span',
      { class: 'grow' },
      h('span', { class: 'label', style: { display: 'block' } }, label),
      sub && h('span', { class: 'sub', style: { display: 'block' } }, sub),
    ),
  )
}

export function dots(total: number, active: number): HTMLElement {
  return h(
    'div',
    { class: 'dots' },
    ...Array.from({ length: total }, (_, i) => h('i', { class: i === active ? 'on' : '' })),
  )
}

export function sheet(content: (close: () => void) => Node): void {
  const close = (): void => {
    backdrop.remove()
    panel.remove()
  }
  const backdrop = h('div', { class: 'sheet-backdrop', onclick: close })
  const panel = h('div', { class: 'sheet', role: 'dialog', 'aria-modal': 'true' })
  panel.appendChild(content(close))
  document.body.append(backdrop, panel)
}

/** Formats a YYYY-MM-DD key as a short local date, with Persian digits when needed. */
export function shortDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number) as [number, number, number]
  const date = new Date(y, m - 1, d)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const diff = Math.round((today.getTime() - date.getTime()) / 86_400_000)
  if (diff === 0) return t().common.today
  if (diff === 1) return t().common.yesterday
  return `${num(d)}/${num(m)}`
}

export function clockString(d = new Date()): string {
  return `${num(String(d.getHours()).padStart(2, '0'))}:${num(
    String(d.getMinutes()).padStart(2, '0'),
  )}`
}
